import React from 'react';

import styles from './NeovarsityManagementSubmittedPage.module.scss';
import SubmittedTable from './SubmittedTable';

function NeovarsityManagementSubmittedPage() {
  return (
    <div className={styles.root}>
      <SubmittedTable />
    </div>
  );
}

export default NeovarsityManagementSubmittedPage;
